<template>
  <nav>
    <v-app-bar app flat class="grey lighten-2">
      <v-app-bar-nav-icon class="grey--text" @click="drawer = !drawer" />
      <v-toolbar-title class="text-uppercase grey--text">
        <span class="">MI</span>
        <span class="grey--text text--darken-1">APA</span>
      </v-toolbar-title>
      <v-spacer></v-spacer>
      <v-btn
        text
        color="red darken-4"
        v-if="$store.getters.user"
        @click="$store.dispatch('logout')"
      >
        <span>SALIR</span>
        <v-icon right>exit_to_app</v-icon>
      </v-btn>
    </v-app-bar>


    <v-navigation-drawer app class="red darken-4" v-model="drawer">
      <v-layout column align-center>
        <v-flex class="mt-8">
          <v-responsive>
            <v-img src="img/logo_blanco.png" alt="apa" />
          </v-responsive>
        </v-flex>
        <!-- <p class="white--text title mt-1">Mi APA</p> -->
        <h3 class="white--text text-h4 heaing mt-1 text-center pa-5">
          {{
            $store.getters.autor.nombres + " " + $store.getters.autor.apellidos
          }}
        </h3>

        <h4 class="white--text text-h4 heaing mb-1 text-center ">
          Número IP {{  $store.getters.autor.ipName }}
        </h4>

        <!-- <p class="white--text caption">Socio activo desde el 14 Oct 1978</p> -->
        <v-flex v-if="false">

          <RegistrarObra />
        </v-flex>
      </v-layout>

      <v-list>
        <v-list-item
          v-for="link in links"
          :key="link.text"
          router
          :to="link.route"
        >
          <v-list-item-action>
            <v-icon class="white--text">{{ link.icon }}</v-icon>
          </v-list-item-action>
          <v-list-item-content class="white--text text-left">
            <v-list-item-title>{{ link.text }}</v-list-item-title>
          </v-list-item-content>
        </v-list-item>
      </v-list>
    </v-navigation-drawer>
  </nav>
</template>

<script>
import RegistrarObra from "@/components/obras/RegistrarObra";
export default {
  data() {
    return {
      drawer: false,
      links: [
        { icon: "dashboard", text: "Inicio", route: "/" },
        { icon: "music_note", text: "Mis Obras", route: "/obras" },
        { icon: "attach_money", text: "Regalías", route: "/regalias" },
        // { icon: "folder", text: "Tramites", route: "/tramites" },
        { icon: "person", text: "Mis Datos", route: "/misdatos" }
      ]
    };
  },
  components: { RegistrarObra }
};
</script>
